import { render, staticRenderFns } from "./logbook.vue?vue&type=template&id=aaa7568e&scoped=true"
import script from "./logbook.vue?vue&type=script&lang=js"
export * from "./logbook.vue?vue&type=script&lang=js"
import style0 from "./logbook.vue?vue&type=style&index=0&id=aaa7568e&prod&scoped=true&lang=scss"
import style1 from "./logbook.vue?vue&type=style&index=1&id=aaa7568e&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "aaa7568e",
  null
  
)

export default component.exports